/*!
 * Copyright Zendesk, Inc.
 * 
 * Use of this source code is governed under the Apache License, Version 2.0
 * found at http://www.apache.org/licenses/LICENSE-2.0
 */
(function (e, a) {
  for (var i in a) {
    e[i] = a[i];
  }
})(exports,
/******/
function (modules) {
  // webpackBootstrap

  /******/
  // The module cache

  /******/
  var installedModules = {};
  /******/

  /******/
  // The require function

  /******/

  function __webpack_require__(moduleId) {
    /******/

    /******/
    // Check if module is in cache

    /******/
    if (installedModules[moduleId]) {
      /******/
      return installedModules[moduleId].exports;
      /******/
    }
    /******/
    // Create a new module (and put it into the cache)

    /******/


    var module = installedModules[moduleId] = {
      /******/
      i: moduleId,

      /******/
      l: false,

      /******/
      exports: {}
      /******/

    };
    /******/

    /******/
    // Execute the module function

    /******/

    modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
    /******/

    /******/
    // Flag the module as loaded

    /******/

    module.l = true;
    /******/

    /******/
    // Return the exports of the module

    /******/

    return module.exports;
    /******/
  }
  /******/

  /******/

  /******/
  // expose the modules object (__webpack_modules__)

  /******/


  __webpack_require__.m = modules;
  /******/

  /******/
  // expose the module cache

  /******/

  __webpack_require__.c = installedModules;
  /******/

  /******/
  // define getter function for harmony exports

  /******/

  __webpack_require__.d = function (exports, name, getter) {
    /******/
    if (!__webpack_require__.o(exports, name)) {
      /******/
      Object.defineProperty(exports, name, {
        enumerable: true,
        get: getter
      });
      /******/
    }
    /******/

  };
  /******/

  /******/
  // define __esModule on exports

  /******/


  __webpack_require__.r = function (exports) {
    /******/
    if (typeof Symbol !== 'undefined' && Symbol.toStringTag) {
      /******/
      Object.defineProperty(exports, Symbol.toStringTag, {
        value: 'Module'
      });
      /******/
    }
    /******/


    Object.defineProperty(exports, '__esModule', {
      value: true
    });
    /******/
  };
  /******/

  /******/
  // create a fake namespace object

  /******/
  // mode & 1: value is a module id, require it

  /******/
  // mode & 2: merge all properties of value into the ns

  /******/
  // mode & 4: return value when already ns object

  /******/
  // mode & 8|1: behave like require

  /******/


  __webpack_require__.t = function (value, mode) {
    /******/
    if (mode & 1) value = __webpack_require__(value);
    /******/

    if (mode & 8) return value;
    /******/

    if (mode & 4 && typeof value === 'object' && value && value.__esModule) return value;
    /******/

    var ns = Object.create(null);
    /******/

    __webpack_require__.r(ns);
    /******/


    Object.defineProperty(ns, 'default', {
      enumerable: true,
      value: value
    });
    /******/

    if (mode & 2 && typeof value != 'string') for (var key in value) {
      __webpack_require__.d(ns, key, function (key) {
        return value[key];
      }.bind(null, key));
    }
    /******/

    return ns;
    /******/
  };
  /******/

  /******/
  // getDefaultExport function for compatibility with non-harmony modules

  /******/


  __webpack_require__.n = function (module) {
    /******/
    var getter = module && module.__esModule ?
    /******/
    function getDefault() {
      return module['default'];
    } :
    /******/
    function getModuleExports() {
      return module;
    };
    /******/

    __webpack_require__.d(getter, 'a', getter);
    /******/


    return getter;
    /******/
  };
  /******/

  /******/
  // Object.prototype.hasOwnProperty.call

  /******/


  __webpack_require__.o = function (object, property) {
    return Object.prototype.hasOwnProperty.call(object, property);
  };
  /******/

  /******/
  // __webpack_public_path__

  /******/


  __webpack_require__.p = "";
  /******/

  /******/

  /******/
  // Load entry module and return exports

  /******/

  return __webpack_require__(__webpack_require__.s = 8);
  /******/
}(
/************************************************************************/

/******/
[
/* 0 */

/***/
function (module, exports) {
  module.exports = require("prop-types");
  /***/
},
/* 1 */

/***/
function (module, exports, __webpack_require__) {
  // extracted by mini-css-extract-plugin
  module.exports = {
    "c-txt": "text__c-txt___h_sle",
    "c-txt__input": "text__c-txt__input___1WZa9",
    "is-rtl": "text__is-rtl___34jGU",
    "c-txt__hint": "text__c-txt__hint___1D8XL",
    "c-txt__label": "text__c-txt__label___1auDg",
    "c-txt__message": "text__c-txt__message___ZHf86",
    "c-txt--inline": "text__c-txt--inline____M6Zg",
    "c-txt--sm__input": "text__c-txt--sm__input___ccfFb",
    "c-txt__input--sm": "text__c-txt__input--sm___2Ht_p",
    "c-txt__input--area": "text__c-txt__input--area___CgvnI",
    "is-resizable": "text__is-resizable___2dDmr",
    "c-txt__input--select": "text__c-txt__input--select___PF6sK",
    "is-focused": "text__is-focused___3v8JO",
    "is-disabled": "text__is-disabled___2n31Q",
    "is-hovered": "text__is-hovered___2Z58_",
    "is-open": "text__is-open___1-cwn",
    "c-txt__input--tag": "text__c-txt__input--tag___3mcd0",
    "c-label": "text__c-label___37I1S",
    "c-tag": "text__c-tag___1TG-v",
    "c-txt__input--focus-inset": "text__c-txt__input--focus-inset___u-wUI",
    "c-txt__input--error": "text__c-txt__input--error___2Iawk",
    "c-txt__input--success": "text__c-txt__input--success___1zx2g",
    "c-txt__input--warning": "text__c-txt__input--warning___3jZlC",
    "c-txt__input--media__figure": "text__c-txt__input--media__figure___1Y9_p",
    "c-txt__input--bare": "text__c-txt__input--bare___1pB_2",
    "c-txt__input--media": "text__c-txt__input--media___985Su",
    "c-txt__input--media__body": "text__c-txt__input--media__body___3jmt5",
    "c-txt__label--regular": "text__c-txt__label--regular___5tttR",
    "c-txt__label--sm": "text__c-txt__label--sm___irq_P",
    "c-txt__message--error": "text__c-txt__message--error___1VdDA",
    "c-txt__message--success": "text__c-txt__message--success___2U34S",
    "c-txt__message--warning": "text__c-txt__message--warning___2Qdga",
    "c-txt__hint--sm": "text__c-txt__hint--sm___19QHs"
  };
  /***/
},
/* 2 */

/***/
function (module, exports) {
  module.exports = require("@zendeskgarden/react-theming");
  /***/
},
/* 3 */

/***/
function (module, exports) {
  module.exports = require("styled-components");
  /***/
},
/* 4 */

/***/
function (module, exports) {
  module.exports = require("classnames");
  /***/
},
/* 5 */

/***/
function (module, exports) {
  module.exports = require("react");
  /***/
},
/* 6 */

/***/
function (module, exports) {
  module.exports = require("@zendeskgarden/react-selection");
  /***/
},
/* 7 */

/***/
function (module, exports) {
  module.exports = require("@zendeskgarden/react-utilities");
  /***/
},
/* 8 */

/***/
function (module, __webpack_exports__, __webpack_require__) {
  "use strict";

  __webpack_require__.r(__webpack_exports__); // EXTERNAL MODULE: external "react"


  var external_react_ = __webpack_require__(5);

  var external_react_default = /*#__PURE__*/__webpack_require__.n(external_react_); // EXTERNAL MODULE: external "@zendeskgarden/react-selection"


  var react_selection_ = __webpack_require__(6); // EXTERNAL MODULE: external "prop-types"


  var external_prop_types_ = __webpack_require__(0);

  var external_prop_types_default = /*#__PURE__*/__webpack_require__.n(external_prop_types_); // EXTERNAL MODULE: external "styled-components"


  var external_styled_components_ = __webpack_require__(3);

  var external_styled_components_default = /*#__PURE__*/__webpack_require__.n(external_styled_components_); // EXTERNAL MODULE: external "classnames"


  var external_classnames_ = __webpack_require__(4);

  var external_classnames_default = /*#__PURE__*/__webpack_require__.n(external_classnames_); // EXTERNAL MODULE: external "@zendeskgarden/react-theming"


  var react_theming_ = __webpack_require__(2); // EXTERNAL MODULE: ./node_modules/@zendeskgarden/css-forms/dist/text.css


  var dist_text = __webpack_require__(1);

  var text_default = /*#__PURE__*/__webpack_require__.n(dist_text); // CONCATENATED MODULE: ./src/views/Input.js


  function _defineProperty(obj, key, value) {
    if (key in obj) {
      Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
      });
    } else {
      obj[key] = value;
    }

    return obj;
  }
  /**
   * Copyright Zendesk, Inc.
   *
   * Use of this source code is governed under the Apache License, Version 2.0
   * found at http://www.apache.org/licenses/LICENSE-2.0.
   */


  var COMPONENT_ID = 'textfields.input';
  var VALIDATION = {
    SUCCESS: 'success',
    WARNING: 'warning',
    ERROR: 'error',
    NONE: 'none'
  };

  var isInvalid = function isInvalid(validation) {
    return validation === VALIDATION.WARNING || validation === VALIDATION.ERROR;
  };
  /**
   * Accepts all `<input>` props
   */


  var Input = external_styled_components_default.a.input.attrs({
    'data-garden-id': COMPONENT_ID,
    'data-garden-version': "3.8.10",
    'aria-invalid': function ariaInvalid(props) {
      return isInvalid(props.validation);
    },
    className: function className(props) {
      var _classNames;

      return external_classnames_default()(text_default.a['c-txt__input'], (_classNames = {}, _defineProperty(_classNames, text_default.a['c-txt__input--sm'], props.small), _defineProperty(_classNames, text_default.a['c-txt__input--tag'], props.tagLayout), _defineProperty(_classNames, text_default.a['c-txt__input--select'], props.select), _defineProperty(_classNames, text_default.a['c-txt__input--media'], props.mediaLayout), _defineProperty(_classNames, text_default.a['c-txt__input--bare'], props.bare), _defineProperty(_classNames, text_default.a['c-txt__input--focus-inset'], props.focusInset), _defineProperty(_classNames, text_default.a['is-disabled'], props.disabled), _defineProperty(_classNames, text_default.a['is-focused'], props.focused), _defineProperty(_classNames, text_default.a['is-hovered'], props.hovered), _defineProperty(_classNames, text_default.a['is-open'], props.open), _defineProperty(_classNames, text_default.a['c-txt__input--success'], props.validation === VALIDATION.SUCCESS), _defineProperty(_classNames, text_default.a['c-txt__input--warning'], props.validation === VALIDATION.WARNING), _defineProperty(_classNames, text_default.a['c-txt__input--error'], props.validation === VALIDATION.ERROR), _defineProperty(_classNames, text_default.a['is-rtl'], Object(react_theming_["isRtl"])(props)), _classNames));
    }
  }).withConfig({
    displayName: "Input",
    componentId: "sc-4gf5js-0"
  })(["", ";"], function (props) {
    return Object(react_theming_["retrieveTheme"])(COMPONENT_ID, props);
  });
  Input.propTypes = {
    /** Allows flush spacing of Tab elements */
    tagLayout: external_prop_types_default.a.bool,

    /** Applies flex layout to support MediaFigure components */
    mediaLayout: external_prop_types_default.a.bool,
    small: external_prop_types_default.a.bool,

    /** Applies select styling */
    select: external_prop_types_default.a.bool,

    /** Removes all borders and styling */
    bare: external_prop_types_default.a.bool,
    disabled: external_prop_types_default.a.bool,
    focused: external_prop_types_default.a.bool,

    /** Applies inset `box-shadow` styling on focus */
    focusInset: external_prop_types_default.a.bool,
    hovered: external_prop_types_default.a.bool,

    /** Displays select open state */
    open: external_prop_types_default.a.bool,
    validation: external_prop_types_default.a.oneOf([VALIDATION.SUCCESS, VALIDATION.WARNING, VALIDATION.ERROR, VALIDATION.NONE])
  };

  Input.hasType = function () {
    return Input;
  };
  /** @component */

  /* harmony default export */


  var views_Input = Input; // CONCATENATED MODULE: ./src/elements/FauxInput.js

  function _typeof(obj) {
    if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") {
      _typeof = function _typeof(obj) {
        return typeof obj;
      };
    } else {
      _typeof = function _typeof(obj) {
        return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
      };
    }

    return _typeof(obj);
  }

  function _extends() {
    _extends = Object.assign || function (target) {
      for (var i = 1; i < arguments.length; i++) {
        var source = arguments[i];

        for (var key in source) {
          if (Object.prototype.hasOwnProperty.call(source, key)) {
            target[key] = source[key];
          }
        }
      }

      return target;
    };

    return _extends.apply(this, arguments);
  }

  function _objectWithoutProperties(source, excluded) {
    if (source == null) return {};

    var target = _objectWithoutPropertiesLoose(source, excluded);

    var key, i;

    if (Object.getOwnPropertySymbols) {
      var sourceSymbolKeys = Object.getOwnPropertySymbols(source);

      for (i = 0; i < sourceSymbolKeys.length; i++) {
        key = sourceSymbolKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
        target[key] = source[key];
      }
    }

    return target;
  }

  function _objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;

    for (i = 0; i < sourceKeys.length; i++) {
      key = sourceKeys[i];
      if (excluded.indexOf(key) >= 0) continue;
      target[key] = source[key];
    }

    return target;
  }

  function _classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) {
      throw new TypeError("Cannot call a class as a function");
    }
  }

  function _defineProperties(target, props) {
    for (var i = 0; i < props.length; i++) {
      var descriptor = props[i];
      descriptor.enumerable = descriptor.enumerable || false;
      descriptor.configurable = true;
      if ("value" in descriptor) descriptor.writable = true;
      Object.defineProperty(target, descriptor.key, descriptor);
    }
  }

  function _createClass(Constructor, protoProps, staticProps) {
    if (protoProps) _defineProperties(Constructor.prototype, protoProps);
    if (staticProps) _defineProperties(Constructor, staticProps);
    return Constructor;
  }

  function _possibleConstructorReturn(self, call) {
    if (call && (_typeof(call) === "object" || typeof call === "function")) {
      return call;
    }

    return _assertThisInitialized(self);
  }

  function _assertThisInitialized(self) {
    if (self === void 0) {
      throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    }

    return self;
  }

  function _getPrototypeOf(o) {
    _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
      return o.__proto__ || Object.getPrototypeOf(o);
    };
    return _getPrototypeOf(o);
  }

  function _inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) {
      throw new TypeError("Super expression must either be null or a function");
    }

    subClass.prototype = Object.create(superClass && superClass.prototype, {
      constructor: {
        value: subClass,
        writable: true,
        configurable: true
      }
    });
    if (superClass) _setPrototypeOf(subClass, superClass);
  }

  function _setPrototypeOf(o, p) {
    _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
      o.__proto__ = p;
      return o;
    };

    return _setPrototypeOf(o, p);
  }

  function FauxInput_defineProperty(obj, key, value) {
    if (key in obj) {
      Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
      });
    } else {
      obj[key] = value;
    }

    return obj;
  }
  /**
   * Copyright Zendesk, Inc.
   *
   * Use of this source code is governed under the Apache License, Version 2.0
   * found at http://www.apache.org/licenses/LICENSE-2.0.
   */


  var DIVInput = views_Input.withComponent('div');
  var FauxInput_VALIDATION = {
    SUCCESS: 'success',
    WARNING: 'warning',
    ERROR: 'error',
    NONE: 'none'
  };
  /**
   * Accepts all `<div>` props
   */

  var FauxInput_FauxInput = /*#__PURE__*/function (_ControlledComponent) {
    _inherits(FauxInput, _ControlledComponent);

    function FauxInput() {
      var _getPrototypeOf2;

      var _this;

      _classCallCheck(this, FauxInput);

      for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
        args[_key] = arguments[_key];
      }

      _this = _possibleConstructorReturn(this, (_getPrototypeOf2 = _getPrototypeOf(FauxInput)).call.apply(_getPrototypeOf2, [this].concat(args)));
      _this.state = {
        focused: false
      };
      return _this;
    }

    _createClass(FauxInput, [{
      key: "render",
      value: function render() {
        var _this2 = this;

        var _this$props = this.props,
            onFocus = _this$props.onFocus,
            onBlur = _this$props.onBlur,
            children = _this$props.children,
            inputRef = _this$props.inputRef,
            otherProps = _objectWithoutProperties(_this$props, ["onFocus", "onBlur", "children", "inputRef"]);

        var _this$getControlledSt = this.getControlledState(),
            focused = _this$getControlledSt.focused;

        return external_react_default.a.createElement(DIVInput, _extends({
          innerRef: inputRef
        }, otherProps, {
          onFocus: Object(react_selection_["composeEventHandlers"])(onFocus, function () {
            _this2.setControlledState({
              focused: true
            });
          }),
          onBlur: Object(react_selection_["composeEventHandlers"])(onBlur, function () {
            _this2.setControlledState({
              focused: false
            });
          }),
          focused: focused,
          "aria-invalid": null // eslint-disable-line jsx-a11y/aria-proptypes

        }), children);
      }
    }]);

    return FauxInput;
  }(react_selection_["ControlledComponent"]);

  FauxInput_defineProperty(FauxInput_FauxInput, "propTypes", {
    inputRef: external_prop_types_default.a.func,

    /** Allows flush spacing of Tab elements */
    tagLayout: external_prop_types_default.a.bool,

    /** Applies flex layout to support MediaFigure components */
    mediaLayout: external_prop_types_default.a.bool,
    small: external_prop_types_default.a.bool,

    /** Applies select styling */
    select: external_prop_types_default.a.bool,

    /** Removes all borders and styling */
    bare: external_prop_types_default.a.bool,
    disabled: external_prop_types_default.a.bool,
    focused: external_prop_types_default.a.bool,

    /** Applies inset `box-shadow` styling on focus */
    focusInset: external_prop_types_default.a.bool,
    hovered: external_prop_types_default.a.bool,

    /** Displays select open state */
    open: external_prop_types_default.a.bool,
    validation: external_prop_types_default.a.oneOf([FauxInput_VALIDATION.SUCCESS, FauxInput_VALIDATION.WARNING, FauxInput_VALIDATION.ERROR, FauxInput_VALIDATION.NONE])
  }); // EXTERNAL MODULE: external "@zendeskgarden/react-utilities"

  var react_utilities_ = __webpack_require__(7); // CONCATENATED MODULE: ./src/views/TextGroup.js


  function TextGroup_defineProperty(obj, key, value) {
    if (key in obj) {
      Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
      });
    } else {
      obj[key] = value;
    }

    return obj;
  }
  /**
   * Copyright Zendesk, Inc.
   *
   * Use of this source code is governed under the Apache License, Version 2.0
   * found at http://www.apache.org/licenses/LICENSE-2.0.
   */


  var TextGroup_COMPONENT_ID = 'textfields.text_group';
  /**
   * Accepts all `<div>` props
   */

  var TextGroup = external_styled_components_default.a.div.attrs({
    'data-garden-id': TextGroup_COMPONENT_ID,
    'data-garden-version': "3.8.10",
    className: function className(props) {
      var _classNames;

      return external_classnames_default()(text_default.a['c-txt'], (_classNames = {}, TextGroup_defineProperty(_classNames, text_default.a['c-txt--inline'], props.inline), TextGroup_defineProperty(_classNames, text_default.a['is-rtl'], Object(react_theming_["isRtl"])(props)), _classNames));
    }
  }).withConfig({
    displayName: "TextGroup",
    componentId: "sc-127gh0a-0"
  })(["", ";"], function (props) {
    return Object(react_theming_["retrieveTheme"])(TextGroup_COMPONENT_ID, props);
  });
  TextGroup.propTypes = {
    inline: external_prop_types_default.a.bool
  };
  /** @component */

  /* harmony default export */

  var views_TextGroup = TextGroup; // CONCATENATED MODULE: ./src/views/Label.js

  function Label_defineProperty(obj, key, value) {
    if (key in obj) {
      Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
      });
    } else {
      obj[key] = value;
    }

    return obj;
  }
  /**
   * Copyright Zendesk, Inc.
   *
   * Use of this source code is governed under the Apache License, Version 2.0
   * found at http://www.apache.org/licenses/LICENSE-2.0.
   */


  var Label_COMPONENT_ID = 'textfields.label';
  /**
   * Accepts all `<label>` props
   */

  var Label = external_styled_components_default.a.label.attrs({
    'data-garden-id': Label_COMPONENT_ID,
    'data-garden-version': "3.8.10",
    className: function className(props) {
      var _classNames;

      return external_classnames_default()(text_default.a['c-txt__label'], (_classNames = {}, Label_defineProperty(_classNames, text_default.a['c-txt__label--regular'], props.regular), Label_defineProperty(_classNames, text_default.a['c-txt__label--sm'], props.small), Label_defineProperty(_classNames, text_default.a['is-rtl'], Object(react_theming_["isRtl"])(props)), _classNames));
    }
  }).withConfig({
    displayName: "Label",
    componentId: "sc-129v0bx-0"
  })(["", ";"], function (props) {
    return Object(react_theming_["retrieveTheme"])(Label_COMPONENT_ID, props);
  });
  Label.propTypes = {
    regular: external_prop_types_default.a.bool,
    small: external_prop_types_default.a.bool
  };

  Label.hasType = function () {
    return Label;
  };
  /** @component */

  /* harmony default export */


  var views_Label = Label; // CONCATENATED MODULE: ./src/views/Textarea.js

  function Textarea_defineProperty(obj, key, value) {
    if (key in obj) {
      Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
      });
    } else {
      obj[key] = value;
    }

    return obj;
  }
  /**
   * Copyright Zendesk, Inc.
   *
   * Use of this source code is governed under the Apache License, Version 2.0
   * found at http://www.apache.org/licenses/LICENSE-2.0.
   */


  var Textarea_COMPONENT_ID = 'textfields.textarea';
  var Textarea_VALIDATION = {
    SUCCESS: 'success',
    WARNING: 'warning',
    ERROR: 'error',
    NONE: 'none'
  };
  /**
   * Accepts all `<textarea>` props
   */

  var Textarea = external_styled_components_default()(views_Input.withComponent('textarea')).attrs({
    'data-garden-id': Textarea_COMPONENT_ID,
    'data-garden-version': "3.8.10",
    className: function className(props) {
      var _classNames;

      return external_classnames_default()(text_default.a['c-txt__input--area'], (_classNames = {}, Textarea_defineProperty(_classNames, text_default.a['is-resizable'], props.resizable), Textarea_defineProperty(_classNames, text_default.a['is-rtl'], Object(react_theming_["isRtl"])(props)), _classNames));
    }
  }).withConfig({
    displayName: "Textarea",
    componentId: "sc-1alsvvb-0"
  })(["", ";"], function (props) {
    return Object(react_theming_["retrieveTheme"])(Textarea_COMPONENT_ID, props);
  });
  Textarea.propTypes = {
    small: external_prop_types_default.a.bool,
    bare: external_prop_types_default.a.bool,
    disabled: external_prop_types_default.a.bool,
    focused: external_prop_types_default.a.bool,

    /** Applies inset `box-shadow` styling on focus */
    focusInset: external_prop_types_default.a.bool,
    hovered: external_prop_types_default.a.bool,
    resizable: external_prop_types_default.a.bool,
    validation: external_prop_types_default.a.oneOf([Textarea_VALIDATION.SUCCESS, Textarea_VALIDATION.WARNING, Textarea_VALIDATION.ERROR, Textarea_VALIDATION.NONE])
  };

  Textarea.hasType = function () {
    return Textarea;
  };
  /** @component */

  /* harmony default export */


  var views_Textarea = Textarea; // CONCATENATED MODULE: ./src/views/Hint.js

  function Hint_defineProperty(obj, key, value) {
    if (key in obj) {
      Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
      });
    } else {
      obj[key] = value;
    }

    return obj;
  }
  /**
   * Copyright Zendesk, Inc.
   *
   * Use of this source code is governed under the Apache License, Version 2.0
   * found at http://www.apache.org/licenses/LICENSE-2.0.
   */


  var Hint_COMPONENT_ID = 'textfields.hint';
  /**
   * Accepts all `<div>` props
   */

  var Hint = external_styled_components_default.a.div.attrs({
    'data-garden-id': Hint_COMPONENT_ID,
    'data-garden-version': "3.8.10",
    className: function className(props) {
      var _classNames;

      return external_classnames_default()(text_default.a['c-txt__hint'], (_classNames = {}, Hint_defineProperty(_classNames, text_default.a['c-txt__hint--sm'], props.small), Hint_defineProperty(_classNames, text_default.a['is-rtl'], Object(react_theming_["isRtl"])(props)), _classNames));
    }
  }).withConfig({
    displayName: "Hint",
    componentId: "sc-1pcaoos-0"
  })(["", ";"], function (props) {
    return Object(react_theming_["retrieveTheme"])(Hint_COMPONENT_ID, props);
  });
  Hint.propTypes = {
    small: external_prop_types_default.a.bool
  };

  Hint.hasType = function () {
    return Hint;
  };
  /** @component */

  /* harmony default export */


  var views_Hint = Hint; // CONCATENATED MODULE: ./src/elements/TextField.js

  function TextField_typeof(obj) {
    if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") {
      TextField_typeof = function _typeof(obj) {
        return typeof obj;
      };
    } else {
      TextField_typeof = function _typeof(obj) {
        return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
      };
    }

    return TextField_typeof(obj);
  }

  function TextField_objectWithoutProperties(source, excluded) {
    if (source == null) return {};
    var target = TextField_objectWithoutPropertiesLoose(source, excluded);
    var key, i;

    if (Object.getOwnPropertySymbols) {
      var sourceSymbolKeys = Object.getOwnPropertySymbols(source);

      for (i = 0; i < sourceSymbolKeys.length; i++) {
        key = sourceSymbolKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
        target[key] = source[key];
      }
    }

    return target;
  }

  function TextField_objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;

    for (i = 0; i < sourceKeys.length; i++) {
      key = sourceKeys[i];
      if (excluded.indexOf(key) >= 0) continue;
      target[key] = source[key];
    }

    return target;
  }

  function TextField_classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) {
      throw new TypeError("Cannot call a class as a function");
    }
  }

  function TextField_defineProperties(target, props) {
    for (var i = 0; i < props.length; i++) {
      var descriptor = props[i];
      descriptor.enumerable = descriptor.enumerable || false;
      descriptor.configurable = true;
      if ("value" in descriptor) descriptor.writable = true;
      Object.defineProperty(target, descriptor.key, descriptor);
    }
  }

  function TextField_createClass(Constructor, protoProps, staticProps) {
    if (protoProps) TextField_defineProperties(Constructor.prototype, protoProps);
    if (staticProps) TextField_defineProperties(Constructor, staticProps);
    return Constructor;
  }

  function TextField_possibleConstructorReturn(self, call) {
    if (call && (TextField_typeof(call) === "object" || typeof call === "function")) {
      return call;
    }

    return TextField_assertThisInitialized(self);
  }

  function TextField_assertThisInitialized(self) {
    if (self === void 0) {
      throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    }

    return self;
  }

  function TextField_getPrototypeOf(o) {
    TextField_getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
      return o.__proto__ || Object.getPrototypeOf(o);
    };
    return TextField_getPrototypeOf(o);
  }

  function TextField_inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) {
      throw new TypeError("Super expression must either be null or a function");
    }

    subClass.prototype = Object.create(superClass && superClass.prototype, {
      constructor: {
        value: subClass,
        writable: true,
        configurable: true
      }
    });
    if (superClass) TextField_setPrototypeOf(subClass, superClass);
  }

  function TextField_setPrototypeOf(o, p) {
    TextField_setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
      o.__proto__ = p;
      return o;
    };

    return TextField_setPrototypeOf(o, p);
  }

  function TextField_defineProperty(obj, key, value) {
    if (key in obj) {
      Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
      });
    } else {
      obj[key] = value;
    }

    return obj;
  }
  /**
   * Copyright Zendesk, Inc.
   *
   * Use of this source code is governed under the Apache License, Version 2.0
   * found at http://www.apache.org/licenses/LICENSE-2.0.
   */

  /** Accepts all `<div>` props */


  var TextField_TextField = /*#__PURE__*/function (_ControlledComponent) {
    TextField_inherits(TextField, _ControlledComponent);

    function TextField() {
      var _getPrototypeOf2;

      var _this;

      TextField_classCallCheck(this, TextField);

      for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
        args[_key] = arguments[_key];
      }

      _this = TextField_possibleConstructorReturn(this, (_getPrototypeOf2 = TextField_getPrototypeOf(TextField)).call.apply(_getPrototypeOf2, [this].concat(args)));
      _this.state = {
        id: react_selection_["IdManager"].generateId('garden-text-field')
      };
      return _this;
    }

    TextField_createClass(TextField, [{
      key: "render",
      value: function render() {
        var _this$getControlledSt = this.getControlledState(),
            id = _this$getControlledSt.id;

        var _this$props = this.props,
            children = _this$props.children,
            otherProps = TextField_objectWithoutProperties(_this$props, ["children"]);
        var isDescribed = false;
        external_react_["Children"].forEach(children, function (child) {
          if (Object(react_utilities_["hasType"])(child, views_Hint)) {
            isDescribed = true;
          }
        });
        return external_react_default.a.createElement(react_selection_["FieldContainer"], {
          id: id
        }, function (_ref) {
          var getLabelProps = _ref.getLabelProps,
              getInputProps = _ref.getInputProps,
              getHintProps = _ref.getHintProps;
          return external_react_default.a.createElement(views_TextGroup, otherProps, external_react_["Children"].map(children, function (child) {
            if (!Object(external_react_["isValidElement"])(child)) {
              return child;
            }

            if (Object(react_utilities_["hasType"])(child, views_Label)) {
              return Object(external_react_["cloneElement"])(child, getLabelProps(child.props));
            }

            if (Object(react_utilities_["hasType"])(child, views_Input) || Object(react_utilities_["hasType"])(child, views_Textarea)) {
              return Object(external_react_["cloneElement"])(child, getInputProps(child.props, {
                isDescribed: isDescribed
              }));
            }

            if (Object(react_utilities_["hasType"])(child, views_Hint)) {
              return Object(external_react_["cloneElement"])(child, getHintProps(child.props));
            }

            return child;
          }));
        });
      }
    }]);
    return TextField;
  }(react_selection_["ControlledComponent"]);

  TextField_defineProperty(TextField_TextField, "propTypes", {
    /**
     * The root ID to use for descendants. A unique ID is created if none is provided.
     **/
    id: external_prop_types_default.a.string,

    /**
     * Apply inline styling to all children
     */
    inline: external_prop_types_default.a.bool,
    children: external_prop_types_default.a.node
  }); // CONCATENATED MODULE: ./src/views/MediaFigure.js

  /**
   * Copyright Zendesk, Inc.
   *
   * Use of this source code is governed under the Apache License, Version 2.0
   * found at http://www.apache.org/licenses/LICENSE-2.0.
   */

  var MediaFigure_COMPONENT_ID = 'textfields.media_figure';
  /**
   * Accepts all `<div>` props
   */

  var MediaFigure = external_styled_components_default.a.div.attrs({
    'data-garden-id': MediaFigure_COMPONENT_ID,
    'data-garden-version': "3.8.10",
    className: text_default.a['c-txt__input--media__figure']
  }).withConfig({
    displayName: "MediaFigure",
    componentId: "sc-1g79mon-0"
  })(["", ";"], function (props) {
    return Object(react_theming_["retrieveTheme"])(MediaFigure_COMPONENT_ID, props);
  });
  /** @component */

  /* harmony default export */

  var views_MediaFigure = MediaFigure; // CONCATENATED MODULE: ./src/views/MediaInput.js

  /**
   * Copyright Zendesk, Inc.
   *
   * Use of this source code is governed under the Apache License, Version 2.0
   * found at http://www.apache.org/licenses/LICENSE-2.0.
   */

  var MediaInput_COMPONENT_ID = 'textfields.media_input';
  var MediaInput_VALIDATION = {
    SUCCESS: 'success',
    WARNING: 'warning',
    ERROR: 'error',
    NONE: 'none'
  };
  /**
   * Accepts all `<input>` props
   */

  var MediaInput = external_styled_components_default()(views_Input).attrs({
    'data-garden-id': MediaInput_COMPONENT_ID,
    'data-garden-version': "3.8.10",
    className: text_default.a['c-txt__input--media__body']
  }).withConfig({
    displayName: "MediaInput",
    componentId: "pblls9-0"
  })(["", ";"], function (props) {
    return Object(react_theming_["retrieveTheme"])(MediaInput_COMPONENT_ID, props);
  });
  MediaInput.propTypes = {
    small: external_prop_types_default.a.bool,
    bare: external_prop_types_default.a.bool,
    disabled: external_prop_types_default.a.bool,
    focused: external_prop_types_default.a.bool,
    hovered: external_prop_types_default.a.bool,
    validation: external_prop_types_default.a.oneOf([MediaInput_VALIDATION.SUCCESS, MediaInput_VALIDATION.WARNING, MediaInput_VALIDATION.ERROR, MediaInput_VALIDATION.NONE])
  };
  MediaInput.defaultProps = {
    bare: true
  };
  /** @component */

  /* harmony default export */

  var views_MediaInput = MediaInput; // CONCATENATED MODULE: ./src/views/Message.js

  function Message_defineProperty(obj, key, value) {
    if (key in obj) {
      Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
      });
    } else {
      obj[key] = value;
    }

    return obj;
  }
  /**
   * Copyright Zendesk, Inc.
   *
   * Use of this source code is governed under the Apache License, Version 2.0
   * found at http://www.apache.org/licenses/LICENSE-2.0.
   */


  var Message_COMPONENT_ID = 'textfields.message';
  var Message_VALIDATION = {
    SUCCESS: 'success',
    WARNING: 'warning',
    ERROR: 'error',
    NONE: 'none'
  };
  /**
   * Accepts all `<div>` props
   */

  var Message = external_styled_components_default.a.div.attrs({
    'data-garden-id': Message_COMPONENT_ID,
    'data-garden-version': "3.8.10",
    role: 'alert',
    className: function className(props) {
      var _classNames;

      return external_classnames_default()(text_default.a['c-txt__message'], (_classNames = {}, Message_defineProperty(_classNames, text_default.a['c-txt__message--success'], props.validation === Message_VALIDATION.SUCCESS), Message_defineProperty(_classNames, text_default.a['c-txt__message--warning'], props.validation === Message_VALIDATION.WARNING), Message_defineProperty(_classNames, text_default.a['c-txt__message--error'], props.validation === Message_VALIDATION.ERROR), Message_defineProperty(_classNames, text_default.a['is-rtl'], Object(react_theming_["isRtl"])(props)), _classNames));
    }
  }).withConfig({
    displayName: "Message",
    componentId: "zhe3tc-0"
  })(["", ";"], function (props) {
    return Object(react_theming_["retrieveTheme"])(Message_COMPONENT_ID, props);
  });
  Message.propTypes = {
    validation: external_prop_types_default.a.oneOf([Message_VALIDATION.SUCCESS, Message_VALIDATION.WARNING, Message_VALIDATION.ERROR, Message_VALIDATION.NONE])
  };

  Message.hasType = function () {
    return Message;
  };
  /** @component */

  /* harmony default export */


  var views_Message = Message; // CONCATENATED MODULE: ./src/index.js

  /* concated harmony reexport FauxInput */

  __webpack_require__.d(__webpack_exports__, "FauxInput", function () {
    return FauxInput_FauxInput;
  });
  /* concated harmony reexport TextField */


  __webpack_require__.d(__webpack_exports__, "TextField", function () {
    return TextField_TextField;
  });
  /* concated harmony reexport Hint */


  __webpack_require__.d(__webpack_exports__, "Hint", function () {
    return views_Hint;
  });
  /* concated harmony reexport Input */


  __webpack_require__.d(__webpack_exports__, "Input", function () {
    return views_Input;
  });
  /* concated harmony reexport Label */


  __webpack_require__.d(__webpack_exports__, "Label", function () {
    return views_Label;
  });
  /* concated harmony reexport MediaFigure */


  __webpack_require__.d(__webpack_exports__, "MediaFigure", function () {
    return views_MediaFigure;
  });
  /* concated harmony reexport MediaInput */


  __webpack_require__.d(__webpack_exports__, "MediaInput", function () {
    return views_MediaInput;
  });
  /* concated harmony reexport Message */


  __webpack_require__.d(__webpack_exports__, "Message", function () {
    return views_Message;
  });
  /* concated harmony reexport Textarea */


  __webpack_require__.d(__webpack_exports__, "Textarea", function () {
    return views_Textarea;
  });
  /* concated harmony reexport TextGroup */


  __webpack_require__.d(__webpack_exports__, "TextGroup", function () {
    return views_TextGroup;
  });
  /**
   * Copyright Zendesk, Inc.
   *
   * Use of this source code is governed under the Apache License, Version 2.0
   * found at http://www.apache.org/licenses/LICENSE-2.0.
   */


  if (false) {}
  /***/

}
/******/
]));